import { PersonJobType } from '@api';
import { ShowTableCell } from '@common';
import { DataTableColumn } from 'mantine-datatable';
import { useTranslation } from 'react-i18next';
import { Confirmed, Date } from '../../components';

const TRANS_PATH = 'TOUR_REP_SELF_PROMOTE.TABLE_COLUMNS';

export type UseColumnsReturnType = {
  columns: DataTableColumn<PersonJobType>[];
};

export const useColumns = (): UseColumnsReturnType => {
  const { t } = useTranslation('personDetailsTourRep');

  const columns: DataTableColumn<PersonJobType>[] = [
    {
      accessor: 'showTypeMinified.showDate',
      title: t(`${TRANS_PATH}.DATE`),
      cellsStyle: () => ({
        verticalAlign: 'top',
      }),
      render: (record) => <Date date={record.showTypeMinified.showDate} />,
    },
    {
      accessor: 'showTypeMinified.tourName',
      title: t(`${TRANS_PATH}.SHOW`),
      render: (record) => <ShowTableCell show={record.showTypeMinified} />,
    },
    {
      accessor: 'jobs.tourProd.isConfirmed',
      title: t(`${TRANS_PATH}.TOUR_PROD`),
      render: (record) => <Confirmed jobType={record.jobs.tourProd} />,
    },
    {
      accessor: 'jobs.tourRep.isConfirmed',
      title: t(`${TRANS_PATH}.TOUR_REP`),
      render: (record) => <Confirmed jobType={record.jobs.tourRep} />,
    },
    {
      accessor: 'jobs.tourAcc.isConfirmed',
      title: t(`${TRANS_PATH}.TOUR_ACC`),
      render: (record) => <Confirmed jobType={record.jobs.tourAcc} />,
    },
    {
      accessor: 'jobs.tourSec.isConfirmed',
      title: t(`${TRANS_PATH}.TOUR_SEC`),
      render: (record) => <Confirmed jobType={record.jobs.tourSec} />,
    },
    {
      accessor: 'jobs.tourVip.isConfirmed',
      title: t(`${TRANS_PATH}.TOUR_VIP`),
      render: (record) => <Confirmed jobType={record.jobs.tourVip} />,
    },
    {
      accessor: 'jobs.localProd.isConfirmed',
      title: t(`${TRANS_PATH}.LOCAL_PROD`),
      render: (record) => <Confirmed jobType={record.jobs.localProd} />,
    },
    {
      accessor: 'jobs.localTicketing.isConfirmed',
      title: t(`${TRANS_PATH}.LOCAL_TICKETING`),
      render: (record) => <Confirmed jobType={record.jobs.localTicketing} />,
    },
    {
      accessor: 'jobs.localRepAcc.isConfirmed',
      title: t(`${TRANS_PATH}.LOCAL_REP_ACC`),
      render: (record) => <Confirmed jobType={record.jobs.localRepAcc} />,
    },
  ];

  return { columns };
};
